import React, { useEffect } from 'react';
import config from '../../config.json';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import GetAppIcon from '@mui/icons-material/GetApp';
import styled from 'styled-components';
import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { FilterInput } from '../../../shared/components/FilterInput';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useParams } from 'react-router-dom';
import { Dialog } from '@mui/material';
import { Formik } from 'formik';
import PageTitle from '../../../shared/components/PageTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import FileUploadBox from './FileUploadBox';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { deleteFile, fileDownload, getFileList } from '../../api';

const TableWrapper = styled.div`
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
         background-color: #F59300 !important;
    }
   
    .materialTableStyle {
        .filterAutocomplete{
    
            .closeIcon { 
                position: absolute;
                left: 450px;
                right: 0px;
                top: 20px;
                bottom: 0px;
            }
            .MuiFilledInput-root {
                background-color: #ffffff;
                border-radius: 0;
                height : 35px;
                padding-top : 0px;
            }
            .MuiFilledInput-input {
                padding: none;
                font-size: 12px;
                height : 10px;
            }
            .MuiFilledInput-underline:before {
                border: 0;
            }
            .MuiInputLabel-filled {
                transform: translate(12px,7px) scale(1);
                font-size: 12px;
            }
            .MuiFilledInput-underline:after {
                border: 0;
            }
            .MuiSelect-select:focus {
                background-color: #ffffff;
            }
            .MuiInputLabel-filled.MuiInputLabel-shrink {
                transform: translate(0px,-12px) scale(0.90) !important;
                color: #F59300;
            }}
        table {
            border-collapse: separate;
            border-spacing: 0 1em;
            width: 99%;
            margin: auto;
        }
        th:first-child, td:first-child {
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
        }
        th:last-child, td:last-child {
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
        }
        th {
            font-size: 12px !important;
            white-space: nowrap;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            color: #F59300;
            height: 55px;
        }
        .MuiTableSortLabel-active {
            color: #F59300;
        }
        .MuiTableSortLabel-root:hover {
            color: #F59300;
        }
        .MuiTableSortLabel-icon {
            color: #F59300 !important;
        }
        td {
            position: relative;
            font-size: 12px !important;
            color: #000;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: #fff;
            border: none;
            height: 60px;
        }
        tbody {
            tr {
                position: relative;
                border-radius: 15px;
                transition: all 0.3s linear;
              
                &:hover {
                    box-shadow: 0 10px 6px rgba(0,0,0,0.10), 0 6px 3px rgba(0,0,0,0.10);

                    .actionListDeleteIconPosition {
                        display: block;
                    }
                    .actionListGetAppIconPosition {
                        display: block;
                    }
                    .actionListUploadIconPosition {
                        display: block;
                    }
                }
            }
        }
        .actionListDeleteIconPosition {
            position: absolute;
            top: -16px;
            right: 15px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListGetAppIconPosition {
            position: absolute;
            top: -16px;
            right: 56px;
            display: none;
            transition: all 0.3s linear;
        }
        .actionListUploadIconPosition {
            position: absolute;
            top: -16px;
            right: 97px;
            display: none;
            transition: all 0.3s linear;
        }
       
        .actionBtn {
            padding: 8px;
            background-color: #ffffff;
            box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);

            &:hover {
                background-color: rgba(245,147,0,0.1);
                color: #F59300;
            }
        }
        .actionIcon {
            font-size: 17px;
        }
    }
    .filterRow {
        display: grid;
        grid-template-columns: 3fr 3fr 3fr  2fr 2fr;
        background-color: rgba(245, 147, 0, 0.1);
        height: 60px;
        border-radius: 15px;
        align-items: center;
        grid-column-gap: 10px;
        padding-left: 10px;
        padding-right: 10px;
        width: 99%;
        margin: auto;
    }
    .filterIconSize{
        font-size: 18px;
    }
    .filterDropdown {
        .MuiFilledInput-root {
            background-color: #ffffff;
            border-radius: 0;
        }
        .MuiFilledInput-input {
            padding: 5px 10px 5px;
            font-size: 12px;
        }
        .MuiFilledInput-underline:before {
            border: 0;
        }
        .MuiInputLabel-filled {
            transform: translate(12px,7px) scale(1);
            font-size: 12px;
        }
        .MuiFilledInput-underline:after {
            border: 0;
        }
        .MuiSelect-select:focus {
            background-color: #ffffff;
        }
        .MuiInputLabel-filled.MuiInputLabel-shrink {
            transform: translate(0px,-12px) scale(0.90) !important;
            color: #F59300;
        }
       
    }
`;

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'fileName', numeric: false, label: 'File Name' }
]

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'center' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

export default function File() {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [page, setPage] = React.useState(0);
    const token = config.TOKEN;
    const { id } = useParams();
    const navigate = useNavigate();
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    var [rows, setRows] = React.useState([]);
    var [openPopup, setOpenPopup] = React.useState(false);
    var [recordedId, setRecordedId] = React.useState(null);
    var [filteredRows, setFilteredRows] = React.useState([]);
    var [openPopup, setOpenPopup] = React.useState(false);
    var [deletePopup, setDeletePopup] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    var [loading, setLoading] = React.useState(false);
    var [progress, setProgress] = React.useState(false);
    const fileMsg = () => toast("File not Found!", { progressClassName: classes.customToastProgress });
    const deleteMsg = () => toast("File Deleted Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        recordedId = id
        setRecordedId(id);
        if (recordedId) {
            fetchFileList(id);
        }
    }, []);

    const fetchFileList = async (subFolderId) => {
        try {
            const res = await getFileList(subFolderId);
            if (res.data.successCode === 0) {
                rows = res.data.data
                setRows(rows);
                filteredRows = rows
                setFilteredRows(filteredRows);
            } else {
                errorMessage();
            }
        } catch (err) {
            errorMessage();
        }
    }

    const handleDeleteFile = async () => {
        setLoading(true);
        try {
            const res = await deleteFile(recordedId);
            if (res.data.successCode === 0) {
                deleteMsg();
                fetchFileList(id);
            } else {
                errorMessage();
            }
        } catch (err) {
            errorMessage();
        } finally {
            setLoading(false);
            setTimeout(() => { setDeletePopup(false) }, 500);
        }
    }

    const downloadFile = async (recordedId) => {
        setProgress(true);
        try {
            const res = await fileDownload(recordedId);
            var respData = res.data;
            if (respData.successCode === 0) {
                if (respData.data.fileData != null && respData.data.fileName != null) {
                    const url = 'data: application/pdf;base64,' + respData.data.fileData
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', respData.data.fileName);
                    document.body.appendChild(link);
                    link.click();
                } else {
                    fileMsg();
                }
            } else {
                errorMessage();
            }
        } catch (err) {
            errorMessage();
        } finally {
            setProgress(false);
        }
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    const handelOpenPopup = () => {
        openPopup = true
        setOpenPopup(openPopup);
    }

    const handleClosePopup = () => {
        openPopup = false
        setOpenPopup(openPopup);
        setRecordedId(null);
        setSelectedRow(null);
    }

    // const handleEditOpenPopup = (id) => {
    //     recordedId = id
    //     setRecordedId(recordedId);
    //     openPopup = true
    //     setOpenPopup(openPopup);
    // }

    const openDeletePopup = (id) => {
        recordedId = id
        setRecordedId(recordedId);
        deletePopup = true
        setDeletePopup(deletePopup);
    }

    return (
        <TableWrapper>
            <ToastContainer theme="dark" />
            <Dialog open={deletePopup} closeonescape="true" maxWidth="true" >
                <TableWrapper>
                    <DialogContent className="dialogStyle">
                        <div className={`${classes.root} materialTableStyle`}>
                            Do you want to delete the record?
                        </div>
                        <DialogActions>
                            <Grid container spacing={4} className="mt-1">
                                <Grid item xs={12} sm={12} md={12} className="text-center">
                                    <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => setDeletePopup(false)}>
                                        No
                                    </Button>&nbsp;&nbsp;
                                    <Button type="submit" variant="contained" color="primary" className="noShadow addBtn" onClick={() => handleDeleteFile()}>
                                        {loading ? <CircularProgress size="25px" color="inherit" /> : "Yes"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </DialogContent>
                </TableWrapper>
            </Dialog>
            <Dialog open={openPopup} onClose={handleClosePopup} closeonescape="true" maxWidth="true">
                <TableWrapper>
                    <DialogTitle>
                        <div className="text-right" onClick={handleClosePopup} style={{ cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faWindowClose} className="closeIcon" />
                        </div>
                        <PageTitle>File upload</PageTitle>
                    </DialogTitle>
                    <Dialog open={openPopup} onClose={handleClosePopup} maxWidth="sm" fullWidth>
                        <DialogTitle>
                            <div className="text-right" onClick={handleClosePopup} style={{ cursor: "pointer" }}>
                                <FontAwesomeIcon icon={faWindowClose} className="closeIcon" />
                            </div>
                            <PageTitle>Upload File</PageTitle>
                        </DialogTitle>
                        <FileUploadBox handleClosePopup={handleClosePopup} selectedRow={selectedRow} fetchFileList={fetchFileList} />
                    </Dialog>
                </TableWrapper>
            </Dialog>
            <div className={`${classes.root} materialTableStyle`}>
                <div className="filterRow">
                    <div>
                        <FilterInput placeholder="Search" icon={<FilterListIcon className="filterIconSize" />} />
                    </div>
                    <div></div>
                    <div></div>
                    <Button type="button" variant="contained" className="noShadow w-100 addBtn" onClick={() => window.history.back()}>Back</Button>
                    <Button type="button" variant="contained" className="noShadow w-100 addBtn" onClick={handelOpenPopup}>Add</Button>
                </div>
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {stableSort(filteredRows, getComparator(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((filteredRows, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={filteredRows.id}>
                                            <TableCell>
                                                {filteredRows.fileName}
                                                <div className="actionListGetAppIconPosition">
                                                    <Tooltip title="Download" aria-label="download">
                                                        <IconButton className="actionBtn" aria-label="Download" onClick={() => { downloadFile(filteredRows.id) }}>
                                                            {progress ? <CircularProgress size={17} color="inherit" /> : <GetAppIcon className="actionIcon" />}
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                                <div className="actionListDeleteIconPosition">
                                                    <Tooltip title="Delete" aria-label="delete">
                                                        <IconButton className="actionBtn" aria-label="Delete" onClick={() => openDeletePopup(filteredRows.id)}>
                                                            <DeleteIcon className="actionIcon" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className="paginationLabel"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </TableWrapper>
    );
}